/* eslint-disable react/prop-types */
import React from 'react';

/**
 * "Top event names" / "Report mix" categorical panel (036) on the shared au-panel
 * system — the analog of 034's Top-workout-types / 035's Test-outcomes. Top-5 names
 * by record count, each with its % of Logs. Every value is text + value (label +
 * count + %), never colour alone; reconciles with the Logs total. "(untyped)" appears
 * only when it lands in the Top 5 (server-side rule).
 *
 * Props: { title, items:[{name,count,pct}], logs }
 */
const n = (v) => Number(v || 0).toLocaleString();

const TopNamesPanel = ({ title = 'Top event names', items = [], logs = 0 }) => (
  <div className="au-panel" data-testid="al-topnames">
    <div className="au-panel__head">
      <h4 className="au-panel__title">{title}</h4>
      <span className="au-spacer" />
      <span className="al-panel__total">of {n(logs)} logs</span>
    </div>
    {items.length === 0 ? (
      <div className="au-chart-empty">No logs in this range.</div>
    ) : (
      <ul className="al-toplist">
        {items.map((it) => (
          <li key={it.name} className="al-toprow">
            <span className="al-toprow__name au-ellipsis">{it.name}</span>
            <span className="al-toprow__count tnum">{n(it.count)}</span>
            <span className="al-toprow__pct tnum">{Number(it.pct || 0).toFixed(1)}%</span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default TopNamesPanel;
